import React from 'react';
import { useAuth } from '../context/AuthContext';

/* ─── Per-category SVG Illustrations (white line-art on gradient) ───────────── */

function TechSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Outer chip body */}
      <rect x="80" y="45" width="100" height="80" rx="6" stroke="white" strokeOpacity="0.85" strokeWidth="2.5"/>
      {/* Inner die */}
      <rect x="95" y="60" width="70" height="50" rx="3" stroke="white" strokeOpacity="0.5" strokeWidth="1.5"/>
      {/* Pin rows — left */}
      <line x1="55" y1="65"  x2="80" y2="65"  stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="55" y1="80"  x2="80" y2="80"  stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="55" y1="95"  x2="80" y2="95"  stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="55" y1="110" x2="80" y2="110" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      {/* Pin rows — right */}
      <line x1="180" y1="65"  x2="205" y2="65"  stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="180" y1="80"  x2="205" y2="80"  stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="180" y1="95"  x2="205" y2="95"  stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="180" y1="110" x2="205" y2="110" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      {/* Pin rows — top */}
      <line x1="100" y1="20" x2="100" y2="45" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="120" y1="20" x2="120" y2="45" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="140" y1="20" x2="140" y2="45" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="160" y1="20" x2="160" y2="45" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      {/* Pin rows — bottom */}
      <line x1="100" y1="125" x2="100" y2="150" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="120" y1="125" x2="120" y2="150" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="140" y1="125" x2="140" y2="150" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <line x1="160" y1="125" x2="160" y2="150" stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      {/* Binary text on die */}
      <text x="101" y="82" fill="white" fillOpacity="0.55" fontSize="9" fontFamily="monospace" letterSpacing="1">0110</text>
      <text x="101" y="95" fill="white" fillOpacity="0.55" fontSize="9" fontFamily="monospace" letterSpacing="1">1001</text>
      <text x="101" y="108" fill="white" fillOpacity="0.55" fontSize="9" fontFamily="monospace" letterSpacing="1">1100</text>
      {/* Decorative dots */}
      <circle cx="30"  cy="30"  r="3" fill="white" fillOpacity="0.25"/>
      <circle cx="230" cy="30"  r="5" fill="white" fillOpacity="0.2"/>
      <circle cx="225" cy="145" r="3" fill="white" fillOpacity="0.25"/>
      <circle cx="35"  cy="148" r="4" fill="white" fillOpacity="0.2"/>
    </svg>
  );
}

function FinanceSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Grid lines */}
      <line x1="30" y1="140" x2="240" y2="140" stroke="white" strokeOpacity="0.2" strokeWidth="1"/>
      <line x1="30" y1="108" x2="240" y2="108" stroke="white" strokeOpacity="0.12" strokeWidth="1" strokeDasharray="5 4"/>
      <line x1="30" y1="76"  x2="240" y2="76"  stroke="white" strokeOpacity="0.12" strokeWidth="1" strokeDasharray="5 4"/>
      <line x1="30" y1="44"  x2="240" y2="44"  stroke="white" strokeOpacity="0.12" strokeWidth="1" strokeDasharray="5 4"/>
      {/* Bars */}
      <rect x="40"  y="115" width="22" height="25" rx="3" fill="white" fillOpacity="0.18"/>
      <rect x="75"  y="95"  width="22" height="45" rx="3" fill="white" fillOpacity="0.22"/>
      <rect x="110" y="105" width="22" height="35" rx="3" fill="white" fillOpacity="0.18"/>
      <rect x="145" y="65"  width="22" height="75" rx="3" fill="white" fillOpacity="0.28"/>
      <rect x="180" y="45"  width="22" height="95" rx="3" fill="white" fillOpacity="0.32"/>
      <rect x="215" y="25"  width="22" height="115" rx="3" fill="white" fillOpacity="0.38"/>
      {/* Trend line */}
      <polyline
        points="51,118 86,98 121,108 156,68 191,48 226,28"
        stroke="white" strokeOpacity="0.9" strokeWidth="2.5"
        strokeLinecap="round" strokeLinejoin="round"/>
      {/* Trend dots */}
      <circle cx="51"  cy="118" r="4" fill="white" fillOpacity="0.9"/>
      <circle cx="156" cy="68"  r="4" fill="white" fillOpacity="0.9"/>
      <circle cx="226" cy="28"  r="5" fill="white"/>
      {/* Up arrow at tip */}
      <path d="M221 21 L226 12 L231 21" stroke="white" strokeWidth="2" strokeLinejoin="round" fill="none"/>
    </svg>
  );
}

function FashionSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Large center diamond */}
      <path d="M130 30 L170 85 L130 140 L90 85 Z"
        stroke="white" strokeOpacity="0.85" strokeWidth="2.5" fill="white" fillOpacity="0.08"/>
      {/* Inner diamond facets */}
      <path d="M130 30 L170 85 L130 85 Z" stroke="white" strokeOpacity="0.4" strokeWidth="1"/>
      <path d="M130 30 L90 85  L130 85 Z" stroke="white" strokeOpacity="0.4" strokeWidth="1"/>
      <path d="M130 140 L170 85 L130 85 Z" stroke="white" strokeOpacity="0.3" strokeWidth="1"/>
      <path d="M130 140 L90 85  L130 85 Z" stroke="white" strokeOpacity="0.3" strokeWidth="1"/>
      {/* Small satellite diamonds */}
      <path d="M50 55 L65 75 L50 95 L35 75 Z"
        stroke="white" strokeOpacity="0.45" strokeWidth="1.5" fill="white" fillOpacity="0.05"/>
      <path d="M210 55 L225 75 L210 95 L195 75 Z"
        stroke="white" strokeOpacity="0.45" strokeWidth="1.5" fill="white" fillOpacity="0.05"/>
      <path d="M130 5 L138 16 L130 27 L122 16 Z"
        stroke="white" strokeOpacity="0.4" strokeWidth="1.2" fill="white" fillOpacity="0.06"/>
      {/* Sparkle stars */}
      <path d="M55 30 L57 25 L59 30 L64 32 L59 34 L57 39 L55 34 L50 32 Z"
        fill="white" fillOpacity="0.6"/>
      <path d="M200 130 L201.5 126 L203 130 L207 131.5 L203 133 L201.5 137 L200 133 L196 131.5 Z"
        fill="white" fillOpacity="0.5"/>
      <path d="M35 120 L36 117 L37 120 L40 121 L37 122 L36 125 L35 122 L32 121 Z"
        fill="white" fillOpacity="0.45"/>
      <path d="M220 20 L221 17 L222 20 L225 21 L222 22 L221 25 L220 22 L217 21 Z"
        fill="white" fillOpacity="0.45"/>
      {/* Reflection line */}
      <line x1="130" y1="30" x2="130" y2="140" stroke="white" strokeOpacity="0.15" strokeWidth="1" strokeDasharray="4 4"/>
    </svg>
  );
}

function SportsSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Motion arcs */}
      <path d="M30 85 Q80 20 160 85 Q200 118 240 85"
        stroke="white" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
      <path d="M30 100 Q80 35 160 100 Q200 133 240 100"
        stroke="white" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M30 115 Q80 50 160 115 Q200 148 240 115"
        stroke="white" strokeOpacity="0.25" strokeWidth="1" strokeLinecap="round"/>
      {/* Ball */}
      <circle cx="185" cy="60" r="28" stroke="white" strokeOpacity="0.9" strokeWidth="2.5" fill="white" fillOpacity="0.1"/>
      {/* Ball seams */}
      <path d="M175 36 Q168 60 175 84" stroke="white" strokeOpacity="0.5" strokeWidth="1.5" fill="none"/>
      <path d="M195 36 Q202 60 195 84" stroke="white" strokeOpacity="0.5" strokeWidth="1.5" fill="none"/>
      <line x1="158" y1="58" x2="212" y2="58" stroke="white" strokeOpacity="0.35" strokeWidth="1.5"/>
      <line x1="160" y1="66" x2="210" y2="66" stroke="white" strokeOpacity="0.35" strokeWidth="1.5"/>
      {/* Speed lines */}
      <line x1="40"  y1="55" x2="80"  y2="55" stroke="white" strokeOpacity="0.35" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="50"  y1="65" x2="100" y2="65" stroke="white" strokeOpacity="0.25" strokeWidth="1" strokeLinecap="round"/>
      <line x1="40"  y1="75" x2="90"  y2="75" stroke="white" strokeOpacity="0.2"  strokeWidth="1" strokeLinecap="round"/>
      {/* Stars / energy */}
      <path d="M65 125 L67 120 L69 125 L74 127 L69 129 L67 134 L65 129 L60 127 Z" fill="white" fillOpacity="0.5"/>
      <path d="M225 135 L226.5 131 L228 135 L232 136.5 L228 138 L226.5 142 L225 138 L221 136.5 Z" fill="white" fillOpacity="0.4"/>
    </svg>
  );
}

function HealthSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* ECG / heartbeat baseline */}
      <line x1="20" y1="85" x2="70" y2="85" stroke="white" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round"/>
      {/* Heartbeat spike */}
      <polyline
        points="70,85 90,85 100,55 110,120 120,42 130,130 140,85 160,85"
        stroke="white" strokeOpacity="0.92" strokeWidth="2.5"
        strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="160" y1="85" x2="240" y2="85" stroke="white" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round"/>
      {/* Pulse circles emanating from center */}
      <circle cx="130" cy="85" r="22" stroke="white" strokeOpacity="0.35" strokeWidth="1.5"/>
      <circle cx="130" cy="85" r="38" stroke="white" strokeOpacity="0.2"  strokeWidth="1"/>
      <circle cx="130" cy="85" r="55" stroke="white" strokeOpacity="0.1"  strokeWidth="0.8"/>
      {/* Center dot */}
      <circle cx="130" cy="85" r="6" fill="white" fillOpacity="0.9"/>
      {/* Cross / plus medical icon */}
      <rect x="218" y="24" width="24" height="8" rx="3" fill="white" fillOpacity="0.6"/>
      <rect x="226" y="16" width="8"  height="24" rx="3" fill="white" fillOpacity="0.6"/>
      {/* Small detail dots */}
      <circle cx="30"  cy="40"  r="3" fill="white" fillOpacity="0.3"/>
      <circle cx="50"  cy="140" r="2" fill="white" fillOpacity="0.25"/>
      <circle cx="220" cy="140" r="3" fill="white" fillOpacity="0.3"/>
    </svg>
  );
}

function EducationSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Graduation cap */}
      <polygon points="130,25 195,55 130,70 65,55"
        stroke="white" strokeOpacity="0.9" strokeWidth="2" fill="white" fillOpacity="0.1"/>
      <line x1="130" y1="55" x2="130" y2="90" stroke="white" strokeOpacity="0.7" strokeWidth="2"/>
      <path d="M100 72 Q100 100 130 105 Q160 100 160 72"
        stroke="white" strokeOpacity="0.75" strokeWidth="2" fill="white" fillOpacity="0.08"/>
      {/* Tassel */}
      <line x1="195" y1="55" x2="195" y2="82" stroke="white" strokeOpacity="0.6" strokeWidth="2"/>
      <circle cx="195" cy="82" r="4" fill="white" fillOpacity="0.7"/>
      {/* Book stack */}
      <rect x="38" y="108" width="70" height="12" rx="3" fill="white" fillOpacity="0.25"/>
      <rect x="42" y="122" width="64" height="12" rx="3" fill="white" fillOpacity="0.2"/>
      <rect x="46" y="136" width="56" height="12" rx="3" fill="white" fillOpacity="0.15"/>
      {/* Book spines */}
      <line x1="52" y1="108" x2="52" y2="120" stroke="white" strokeOpacity="0.3" strokeWidth="1"/>
      <line x1="56" y1="122" x2="56" y2="134" stroke="white" strokeOpacity="0.25" strokeWidth="1"/>
      {/* Stars of knowledge */}
      <path d="M195 110 L197 105 L199 110 L204 112 L199 114 L197 119 L195 114 L190 112 Z"
        fill="white" fillOpacity="0.55"/>
      <path d="M220 135 L221 132 L222 135 L225 136 L222 137 L221 140 L220 137 L217 136 Z"
        fill="white" fillOpacity="0.4"/>
      {/* Rays from cap */}
      <line x1="130" y1="25" x2="130" y2="14" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1="150" y1="30" x2="157" y2="22" stroke="white" strokeOpacity="0.25" strokeWidth="1" strokeLinecap="round"/>
      <line x1="110" y1="30" x2="103" y2="22" stroke="white" strokeOpacity="0.25" strokeWidth="1" strokeLinecap="round"/>
    </svg>
  );
}

function SpaceSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Stars scattered */}
      {[
        [25,20],[60,12],[85,35],[200,18],[230,30],[240,8],
        [22,100],[18,140],[40,155],[215,148],[245,130],[250,60],
      ].map(([x,y],i) => (
        <circle key={i} cx={x} cy={y} r={i%3===0?2:1.2} fill="white" fillOpacity={0.4+i*0.04}/>
      ))}
      {/* Larger sparkle stars */}
      <path d="M42 50 L43.5 46 L45 50 L49 51.5 L45 53 L43.5 57 L42 53 L38 51.5 Z" fill="white" fillOpacity="0.55"/>
      <path d="M228 90 L229.5 86 L231 90 L235 91.5 L231 93 L229.5 97 L228 93 L224 91.5 Z" fill="white" fillOpacity="0.45"/>
      <path d="M55 135 L56 132 L57 135 L60 136 L57 137 L56 140 L55 137 L52 136 Z" fill="white" fillOpacity="0.4"/>
      {/* Planet body */}
      <circle cx="145" cy="85" r="48" stroke="white" strokeOpacity="0.85" strokeWidth="2" fill="white" fillOpacity="0.07"/>
      {/* Planet surface bands */}
      <path d="M100 72 Q145 66 190 72" stroke="white" strokeOpacity="0.25" strokeWidth="1.5" fill="none"/>
      <path d="M97 85 Q145 80 193 85" stroke="white" strokeOpacity="0.2"  strokeWidth="1.5" fill="none"/>
      <path d="M100 98 Q145 104 190 98" stroke="white" strokeOpacity="0.25" strokeWidth="1.5" fill="none"/>
      {/* Rings (elliptical orbit) */}
      <ellipse cx="145" cy="85" rx="78" ry="20"
        stroke="white" strokeOpacity="0.7" strokeWidth="2" fill="none"/>
      {/* Clip the ring behind planet — upper half hidden */}
      <ellipse cx="145" cy="85" rx="78" ry="20"
        stroke="white" strokeOpacity="0" strokeWidth="0"
        fill="white" fillOpacity="0.07"/>
      {/* Moon */}
      <circle cx="52" cy="62" r="14" stroke="white" strokeOpacity="0.65" strokeWidth="1.5" fill="white" fillOpacity="0.06"/>
      <circle cx="46" cy="57" r="3" stroke="white" strokeOpacity="0.35" strokeWidth="1" fill="none"/>
      <circle cx="56" cy="68" r="2" stroke="white" strokeOpacity="0.3"  strokeWidth="1" fill="none"/>
    </svg>
  );
}

function ScienceSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Atom nucleus */}
      <circle cx="130" cy="85" r="10" fill="white" fillOpacity="0.8"/>
      {/* Electron orbits */}
      <ellipse cx="130" cy="85" rx="65" ry="25"
        stroke="white" strokeOpacity="0.7" strokeWidth="1.8" fill="none"/>
      <ellipse cx="130" cy="85" rx="65" ry="25"
        stroke="white" strokeOpacity="0.7" strokeWidth="1.8" fill="none"
        transform="rotate(60 130 85)"/>
      <ellipse cx="130" cy="85" rx="65" ry="25"
        stroke="white" strokeOpacity="0.7" strokeWidth="1.8" fill="none"
        transform="rotate(-60 130 85)"/>
      {/* Electrons */}
      <circle cx="195" cy="85" r="5.5" fill="white" fillOpacity="0.9"/>
      <circle cx="97"  cy="62" r="5.5" fill="white" fillOpacity="0.9" transform="rotate(60 130 85)"/>
      <circle cx="97"  cy="62" r="5.5" fill="white" fillOpacity="0.9" transform="rotate(-60 130 85)"/>
      {/* Flask (bottom-left) */}
      <path d="M42 130 L52 105 L52 80 L68 80 L68 105 L78 130 Z"
        stroke="white" strokeOpacity="0.7" strokeWidth="1.8" fill="white" fillOpacity="0.07"
        strokeLinejoin="round"/>
      <line x1="52" y1="90" x2="68" y2="90" stroke="white" strokeOpacity="0.4" strokeWidth="1.5"/>
      {/* Liquid in flask */}
      <path d="M44 122 Q52 110 68 110 L76 128 Z" fill="white" fillOpacity="0.2"/>
      {/* Bubbles in flask */}
      <circle cx="56" cy="118" r="2.5" fill="white" fillOpacity="0.45"/>
      <circle cx="64" cy="115" r="1.8" fill="white" fillOpacity="0.4"/>
      <circle cx="60" cy="122" r="1.5" fill="white" fillOpacity="0.35"/>
      {/* Decorative molecular bonds */}
      <circle cx="210" cy="135" r="6" stroke="white" strokeOpacity="0.55" strokeWidth="1.5" fill="none"/>
      <circle cx="230" cy="125" r="6" stroke="white" strokeOpacity="0.55" strokeWidth="1.5" fill="none"/>
      <line x1="216" y1="131" x2="224" y2="129" stroke="white" strokeOpacity="0.4" strokeWidth="1.5"/>
      <circle cx="240" cy="145" r="6" stroke="white" strokeOpacity="0.5"  strokeWidth="1.5" fill="none"/>
      <line x1="234" y1="130" x2="238" y2="140" stroke="white" strokeOpacity="0.4" strokeWidth="1.5"/>
      {/* Stars */}
      <path d="M205 22 L207 17 L209 22 L214 24 L209 26 L207 31 L205 26 L200 24 Z" fill="white" fillOpacity="0.5"/>
      <path d="M25 55 L26.5 51 L28 55 L32 56.5 L28 58 L26.5 62 L25 58 L21 56.5 Z"  fill="white" fillOpacity="0.4"/>
    </svg>
  );
}

function IndiaFinanceSVG() {
  return (
    <svg viewBox="0 0 260 170" fill="none" className="w-full h-full" aria-hidden="true">
      {/* Grid lines */}
      <line x1="30" y1="140" x2="240" y2="140" stroke="white" strokeOpacity="0.2" strokeWidth="1"/>
      <line x1="30" y1="108" x2="240" y2="108" stroke="white" strokeOpacity="0.12" strokeWidth="1" strokeDasharray="5 4"/>
      <line x1="30" y1="76"  x2="240" y2="76"  stroke="white" strokeOpacity="0.12" strokeWidth="1" strokeDasharray="5 4"/>
      {/* Candlestick chart */}
      {/* Wick lines */}
      <line x1="51"  y1="100" x2="51"  y2="130" stroke="white" strokeOpacity="0.55" strokeWidth="1.5"/>
      <line x1="86"  y1="80"  x2="86"  y2="115" stroke="white" strokeOpacity="0.55" strokeWidth="1.5"/>
      <line x1="121" y1="90"  x2="121" y2="125" stroke="white" strokeOpacity="0.55" strokeWidth="1.5"/>
      <line x1="156" y1="55"  x2="156" y2="95"  stroke="white" strokeOpacity="0.55" strokeWidth="1.5"/>
      <line x1="191" y1="40"  x2="191" y2="80"  stroke="white" strokeOpacity="0.55" strokeWidth="1.5"/>
      <line x1="226" y1="28"  x2="226" y2="68"  stroke="white" strokeOpacity="0.55" strokeWidth="1.5"/>
      {/* Bearish candles (red → white low opacity) */}
      <rect x="41"  y="105" width="20" height="20" rx="2" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.4" strokeWidth="1"/>
      <rect x="111" y="95"  width="20" height="22" rx="2" fill="white" fillOpacity="0.15" stroke="white" strokeOpacity="0.4" strokeWidth="1"/>
      {/* Bullish candles (green → white high opacity) */}
      <rect x="76"  y="85"  width="20" height="22" rx="2" fill="white" fillOpacity="0.35" stroke="white" strokeOpacity="0.6" strokeWidth="1"/>
      <rect x="146" y="62"  width="20" height="28" rx="2" fill="white" fillOpacity="0.35" stroke="white" strokeOpacity="0.6" strokeWidth="1"/>
      <rect x="181" y="48"  width="20" height="28" rx="2" fill="white" fillOpacity="0.38" stroke="white" strokeOpacity="0.65" strokeWidth="1"/>
      <rect x="216" y="36"  width="20" height="28" rx="2" fill="white" fillOpacity="0.42" stroke="white" strokeOpacity="0.7" strokeWidth="1"/>
      {/* Uptrend line */}
      <path d="M51 120 L86 97 L121 108 L156 76 L191 64 L226 50"
        stroke="white" strokeOpacity="0.55" strokeWidth="1.5" strokeDasharray="4 3" fill="none"/>
      {/* Rupee symbol */}
      <text x="32" y="52" fill="white" fillOpacity="0.85" fontSize="22" fontWeight="bold" fontFamily="serif">₹</text>
      {/* Sensex / Nifty labels */}
      <text x="32" y="68" fill="white" fillOpacity="0.45" fontSize="7" fontFamily="monospace" letterSpacing="0.5">SENSEX</text>
      <text x="32" y="78" fill="white" fillOpacity="0.45" fontSize="7" fontFamily="monospace" letterSpacing="0.5">NIFTY50</text>
      {/* Corner dots */}
      <circle cx="30"  cy="30"  r="3" fill="white" fillOpacity="0.2"/>
      <circle cx="240" cy="155" r="3" fill="white" fillOpacity="0.2"/>
    </svg>
  );
}

/* ─── Config ────────────────────────────────────────────────────────────────── */

const BANNER_CONFIG = {
  technology: {
    gradient:  'from-indigo-600 via-indigo-700 to-purple-800',
    glow:      'shadow-indigo-900/60',
    tagline:   'Innovations shaping tomorrow',
    Svg:       TechSVG,
  },
  finance: {
    gradient:  'from-emerald-600 via-teal-600 to-cyan-800',
    glow:      'shadow-emerald-900/60',
    tagline:   'Markets, investment & global economy',
    Svg:       FinanceSVG,
  },
  india_finance: {
    gradient:  'from-slate-500 via-slate-600 to-slate-800',
    glow:      'shadow-slate-900/60',
    tagline:   'Sensex · Nifty · BSE · NSE · Indian markets',
    Svg:       IndiaFinanceSVG,
  },
  fashion: {
    gradient:  'from-pink-500 via-rose-600 to-fuchsia-700',
    glow:      'shadow-pink-900/60',
    tagline:   'Style, trends & luxury culture',
    Svg:       FashionSVG,
  },
  sports: {
    gradient:  'from-orange-500 via-amber-600 to-orange-700',
    glow:      'shadow-orange-900/60',
    tagline:   'Game highlights & athlete news',
    Svg:       SportsSVG,
  },
  health: {
    gradient:  'from-teal-500 via-cyan-600 to-teal-700',
    glow:      'shadow-teal-900/60',
    tagline:   'Wellness, medicine & wellbeing',
    Svg:       HealthSVG,
  },
  education: {
    gradient:  'from-blue-600 via-blue-700 to-indigo-800',
    glow:      'shadow-blue-900/60',
    tagline:   'Learning, knowledge & academia',
    Svg:       EducationSVG,
  },
  space: {
    gradient:  'from-violet-800 via-purple-900 to-slate-900',
    glow:      'shadow-violet-900/60',
    tagline:   'Cosmos, missions & deep space discovery',
    Svg:       SpaceSVG,
  },
  science: {
    gradient:  'from-purple-600 via-violet-700 to-indigo-900',
    glow:      'shadow-purple-900/60',
    tagline:   'Breakthroughs, labs & research frontiers',
    Svg:       ScienceSVG,
  },
};

/* ─── Component ─────────────────────────────────────────────────────────────── */

export default function CategoryBanner({ category, label, articleCount }) {
  const config      = BANNER_CONFIG[category];
  const { user }    = useAuth();
  if (!config) return null;
  const { gradient, glow, tagline, Svg } = config;

  return (
    <div className={`relative overflow-hidden rounded-2xl bg-gradient-to-r ${gradient} shadow-xl ${glow} mb-7 animate-slide-in-down transition-shadow duration-300 hover:shadow-2xl`}>
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}
      />

      {/* ── Top user row ── */}
      <div className="relative flex items-center justify-end px-8 pt-3.5 pb-0 gap-2.5">
        <div className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center shrink-0">
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <span className="text-white text-sm font-semibold tracking-wide">{user?.name}</span>
        {user?.role === 'admin' && (
          <span className="px-2 py-0.5 bg-white/20 text-white text-[10px] font-bold rounded-full tracking-wide">
            Admin
          </span>
        )}
      </div>

      {/* ── Main banner content ── */}
      <div className="relative flex items-center justify-between px-8 pt-2 pb-5">
        <div className="flex-1 min-w-0 pr-4 pl-3">
          {/* Section name */}
          <div className="flex items-center gap-1.5 mb-1 animate-scale-in">
            {category === 'finance' && (
              <span className="text-white/80 font-bold" style={{ fontSize: '18px', fontFamily: 'Georgia, serif' }}>$</span>
            )}
            {category === 'india_finance' && (
              <span className="text-white/80 font-bold" style={{ fontSize: '18px', fontFamily: 'Georgia, serif' }}>₹</span>
            )}
            <span className="text-white font-extrabold tracking-wide" style={{ fontSize: '20px', fontFamily: 'Georgia, serif' }}>{label}</span>
          </div>

          {/* Tagline */}
          <p className="text-white/80 font-medium text-sm leading-snug animate-fade-in" style={{ animationDelay: '0.1s' }}>
            {tagline}
          </p>

        </div>

        {/* SVG illustration */}
        <div className="w-44 h-28 shrink-0 opacity-90">
          <Svg />
        </div>
      </div>
    </div>
  );
}
